import React, { useContext } from "react";
import "../styles/basketItemDiscount.css";
import "../styles/summary.css";
import "../styles/position.css";
import { useSelector } from "react-redux";
import Coupon from "../Components/Coupon";
import { LanguageContext } from "../context/language/LanguageContext";
import appConst from "../Utilities/appConst.json";
import UncombinededCoupon from "./UncombinededCoupon";
import UncombinededCouponWithInfo from "./UncombinededCouponWithInfo";
import UnavailableCoupon from "./UnavailableCoupon";

function CombinededCoupon({ selectableCoupons = [], unavailableCoupons = [] }) {
  return (
    <>
      {selectableCoupons.map((coupon, index) => (
        <Coupon key={index} coupon={coupon} />
      ))}
      {unavailableCoupons.map((coupon, index) => (
        <UnavailableCoupon key={index} coupon={coupon} />
      ))}
    </>
  );
}

export default function Coupons() {
  const languageContext = useContext(LanguageContext);
  const serviceCodeCoupons = useSelector(
    (state) => state.coupons.serviceCodeCoupons
  );
  const collectionBucketCoupons = useSelector(
    (state) => state.coupons.collectionBucketCoupons
  );
  const selectableCoupons = useSelector(
    (state) => state.coupons.selectableCoupons
  );
  const unavailableCoupons = useSelector(
    (state) => state.coupons.unavailableCoupons
  );
  const hasServiceCodeCoupons = Boolean(serviceCodeCoupons?.length);
  const hasCollectionBucketCoupons = Boolean(collectionBucketCoupons?.length);
  const hasRegularCoupons = Boolean(
    selectableCoupons?.length || unavailableCoupons?.length
  );

  const text =
    hasServiceCodeCoupons
      ? languageContext.getTranslation(appConst.FIRST_SERVIC_CODE_COUPON_TEXT)
      : hasCollectionBucketCoupons
      ? languageContext.getTranslation(appConst.COLLECTION_BUCKET_COUPON_TEXT)
      : hasRegularCoupons
      ? languageContext.getTranslation(appConst.FIRST_COUPON_TEXT)
      : "";

  return (
    <>
      {text && (
        <div
          className="summary_coupons_continer summary_container"
          data-testid="summary-coupons"
        >
          <div className="summary_coupons" data-testid="summary-coupons-list">
            <div className="summary_coupon notation" data-testid="summary-coupons-note">
              <div className="rtl_column_box_position">
                <div className="box_item_l">{text}</div>
              </div>
            </div>
            {hasServiceCodeCoupons ? (
              serviceCodeCoupons.map((coupon, index) => (
                <UncombinededCoupon key={index} coupon={coupon} />
              ))
            ) : hasCollectionBucketCoupons ? (
              collectionBucketCoupons.map((coupon, index) => (
                <UncombinededCouponWithInfo key={index} coupon={coupon} />
              ))
            ) : (
              <CombinededCoupon
                selectableCoupons={selectableCoupons || []}
                unavailableCoupons={unavailableCoupons || []}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
